import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './login';
import Forms from './forms3/index-v3'
import Solicitacoes from './solicitacoes';
import { CriarConta, Esqueci, DefinirSenha, Redefinir } from './conta';
import { isAuthenticated } from "./services/withAuth";
import FormsGestores from './forms_gestores/index'
// F6 (15/08/2026): envio-massa (mala direta de e-mail) removido — estava
// quebrado nas duas pontas (URL errada aqui, rota fail-closed no backend).

function PrivateRoute({ children }) {
    let auth = isAuthenticated();
    // 🔗 16/09: o link do e-mail (/solicitacoes?chamado=N) passa pela entrada — o
    // destino vai JUNTO, senão o cliente entra e cai no formulário de chamado novo.
    const local = useLocation();
    return auth ? <>{children}</> : <Navigate to="/authenticate" replace state={{ de: local.pathname + local.search }} />;
}

// (04/09) A CONTA do cliente: quatro telas públicas no molde da entrada. Os
// links dos e-mails apontam para /definir-senha?token= e /reset?id=&token=
// (o mesmo formato que o Radar usa — é o mesmo backoffice que os gera).
const Rotas = () => (
    <BrowserRouter>
        <Routes>
            <Route element={<Login />} path="/authenticate" exact />
            <Route element={<CriarConta />} path="/criar-conta" />
            <Route element={<Esqueci />} path="/esqueci" />
            <Route element={<DefinirSenha />} path="/definir-senha" />
            <Route element={<Redefinir />} path="/reset" />
            <Route
                path="/"
                element={
                    <PrivateRoute>
                        <Forms />
                    </PrivateRoute>
                }
            />
            <Route
                path="/forms"
                element={
                    <PrivateRoute>
                        <Forms />
                    </PrivateRoute>
                }
            />
            <Route
                path="/solicitacoes"
                element={
                    <PrivateRoute>
                        <Solicitacoes />
                    </PrivateRoute>
                }
            />
            <Route
                path="/forms-gestores"
                element={
                    <PrivateRoute>
                        <FormsGestores />
                    </PrivateRoute>
                }
            />
        </Routes>
    </BrowserRouter>
)

export default Rotas;
